// extracted by mini-css-extract-plugin
export var hero = "blog-post-module--hero--2tkxa";
export var title = "blog-post-module--title--1uZ-o";